import { gql } from "@apollo/client";

export const PodcastBaseFragment = gql`
  fragment PodcastBaseFragment on Podcast {
    documentId
    title
    slug
    briefDescription
    publicationDate
    cover {
      url
      alternativeText
      mime
    }
  }
`;

export const PodcastDetailFragment = gql`
  fragment PodcastDetailFragment on Podcast {
    documentId
    title
    slug
    briefDescription
    fullDescription
    publicationDate
    createdAt
    publishedAt
    platforms {
      url
      platform {
        name
        icon {
          url
          alternativeText
        }
      }
    }
    cover {
      url
      alternativeText
      mime
    }
  }
`;

export const PodcastDefaultContentTemplateFragment = gql`
  fragment PodcastDefaultContentTemplateFragment on PodcastDefaultContentTemplateDynamicZone {
    __typename
    ... on ComponentCommonH3 {
      text
    }
    ... on ComponentCommonMedia {
      media {
        url
        alternativeText
      }
    }
    ... on ComponentCommonTitle {
      title
    }
    ... on ComponentCommonAuthorDetailed {
      authors: authors_connection {
        nodes {
          name
          role
          bio
          avatar {
            url
            alternativeText
          }
        }
      }
    }
    ... on ComponentCommonDivider {
      id
    }
    ... on ComponentCommonEmbedded {
      link
      provider
    }
    ... on ComponentCommonTextEditor {
      markdownText
    }
    ... on ComponentCommonBullet {
      item {
        text
      }
    }
    ... on ComponentCommonQuote {
      quote
    }
    ... on ComponentCommonFaqComponent {
      faq {
        title
        description
      }
    }
    ... on ComponentCommonTags {
      id
    }
    ... on ComponentCommonRelatedContent {
      id
    }
    ... on ComponentCommonDownloadableContentList {
      list {
        title
        description
        content {
          url
        }
      }
    }
    ... on ComponentCommonAudio {
      transcription
      audio {
        url
        name
      }
    }
    ... on ComponentPodcastPodcastRelated {
      id
      podcasts: podcasts_connection(
        filters: { publishedAt: { notNull: true } }
      ) {
        nodes {
          ...PodcastBaseFragment
          listenings(
            filters: { staff: { documentId: { eq: $userDocumentId } } }
          ) {
            documentId
            listeningTime
            duration
          }
        }
      }
    }
  }
`;
